import HomePage from "@/components/home/HomePage"

const index = () => {
  return <HomePage />
}

export default index
